import React, { useState } from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import megaphonIcon from 'assets/icons/megaphon_icon.svg';
import { SlideoutMenu as Menu } from '../../components/SlideoutMenu';
import './SlideoutWhatsNew.pcss';
import { useWhatsNewItems } from './useWhatsNewItems';
import { WhatsNewItem } from './WhatsNewItem/WhatsNewItem';
import { useDetectOutsideClicks } from '../../../../../common/hooks/use-detect-outside-clicks';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';

export const SlideoutWhatsNew = () => {
  const { whatsNewItems, hideSlideoutMenuOverride } = useWhatsNewItems();
  const dispatch: Dispatch<StoreState> = useDispatch();
  const [wrapperRef, setWrapperRef] = useState<HTMLElement | null>(null);

  const setRef = (ref: HTMLElement) => {
    setWrapperRef(ref);
  };
  useDetectOutsideClicks(() => {
    hideSlideoutMenuOverride();
    dispatch(hideSlideoutMenu());
  }, wrapperRef);

  return (
    <Menu setRef={setRef}>
      <Menu.Header onClose={hideSlideoutMenuOverride}>
        <div className="whats-new-slideout__header-container">
          <div>
            <img
              src={megaphonIcon}
              className="whats-new-slideout__icon"
              alt="Icon"
            />
          </div>
          <div className="whats-new-slideout__header-text">
            What's new in MobileMonkey
          </div>
        </div>
      </Menu.Header>
      <Menu.Content>
        {whatsNewItems.map((i, idx) => (
          <WhatsNewItem {...i} key={idx} />
        ))}
      </Menu.Content>
    </Menu>
  );
};
